<template>
  <div class="btn-filters">
    <label v-if="options.indexOf('yesterday') > -1" class="btn" :class="date == 'yesterday' ? 'btn-blue' : 'btn-green'"
      @click="setDate(-1)">{{ $t('yesterday') }}</label>
    <label v-if="options.indexOf('today') > -1" class="btn" :class="date == 'today' ? 'btn-blue' : 'btn-green'"
      @click="setDate(0)">{{ $t('today') }}</label>
    <label v-if="options.indexOf('tomorrow') > -1" class="btn" :class="date == 'tomorrow' ? 'btn-blue' : 'btn-green'"
      @click="setDate(1)">{{ $t('tomorrow') }}</label>
    <label v-if="options.indexOf('next_week') > -1" class="btn" :class="date == 'next_week' ? 'btn-blue' : 'btn-green'"
      @click="setDate(7)">{{ $t('next_week') }}</label>
    <label v-if="options.indexOf('next_month') > -1" class="btn" :class="date == 'next_month' ? 'btn-blue' : 'btn-green'"
      @click="setDate(31)">{{ $t('next_month') }}</label>
    <label v-if="options.indexOf('from_now') > -1" class="btn" :class="date == 'from_now' ? 'btn-blue' : 'btn-green'"
      @click="setDate('from_now')">{{ $t('from_now') }}</label>
    <button class="btn-black" @click="$emit('reset')" style="float:right">{{ $t("clean_filters") }}</button>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'dateFilter',
  props: ['before', 'after', 'today', 'options', 'initialFilter', 'company'],
  mounted () {
    if (this.before || this.after) {
      return
    }
    this.initialData()
  },
  computed: {
    date: {
      get: function () {
        const today = moment().format('YYYY-MM-DD')
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
        const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD')
        const nextWeek = moment().add(7, 'days').format('YYYY-MM-DD')
        const nextMonth = moment().add(31, 'days').format('YYYY-MM-DD')

        const after = moment(this.after).format('YYYY-MM-DD')
        const before = moment(this.before).format('YYYY-MM-DD')

        if (!this.before && this.after && after === today) return 'from_now'
        else if (after === before) {
          switch (after) {
            case yesterday: return 'yesterday'
            case today: return 'today'
            case tomorrow: return 'tomorrow'
          }
        } else {
          if (after === today) {
            if (before === nextWeek) return 'next_week'
            if (before === nextMonth) return 'next_month'
          }
        }
        return ''
      }
    }
  },
  watch: {
    today () {
      this.setDate(0)
    }
  },
  methods: {
    setDate (addDay) {
      if (addDay === 'from_now') {
        const after = moment(new Date()).format('YYYY-MM-DD')
        this.$emit('update', { after })
      } else {
        var start = addDay
        var end = addDay
        if (addDay > 1) start = 0

        const after = moment(new Date()).add(start, 'days').format('YYYY-MM-DD')
        const before = moment(new Date()).add(end, 'days').format('YYYY-MM-DD')
        this.$emit('update', { after, before })
      }

      if (this.company === 'bw') localStorage.setItem('selectedDate', addDay)
    },
    initialData () {
      const after = moment().format('YYYY-MM-DD')
      const before = moment().format('YYYY-MM-DD')
      const storedDate = localStorage.getItem('selectedDate')
      const dateMap = { yesterday: -1, today: 0, tomorrow: 1, next_week: 7, next_month: 31 }

      if (this.company === 'bw' && storedDate) this.setDate(storedDate)
      else if (this.initialFilter) this.setDate(dateMap[this.initialFilter] || this.initialFilter)
      else this.setDate(0)

      if (this.company !== 'bw') this.$emit('update', { after, before })
    }
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/DateFilter.vue